import React from 'react';
import { PhoneCallIcon, ArrowDownIcon } from 'lucide-react';
const Hero = () => {
  const scrollToTryVoxie = () => {
    const tryVoxieSection = document.getElementById('try-voxie');
    if (tryVoxieSection) {
      tryVoxieSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="bg-gradient-to-r from-[#54d4cb] to-[#3ba69f] text-white py-16 md:py-24" data-id="element-82">
      <div className="container mx-auto px-4" data-id="element-83">
        <div className="flex flex-col md:flex-row items-center" data-id="element-84">
          <div className="md:w-1/2 mb-10 md:mb-0" data-id="element-85">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-86">
              Your AI Offering To Consumers On SMS and Voice
            </h1>
            <p className="text-xl mb-8 text-[#e3f7f6]" data-id="element-87">
              Voxie is a ChatGPT-like AI on a local phone number, instead of a
              website or app, making it accessible even if offline. We partner
              with telecoms and brands to white-label a complete AI offering to
              customers.
            </p>
            <div className="flex justify-center md:justify-start" data-id="element-88">
              <button onClick={scrollToTryVoxie} className="bg-white text-[#54d4cb] px-8 py-4 rounded-md font-medium hover:bg-[#e3f7f6] transition-colors flex items-center justify-center text-lg" data-id="element-89">
                Try It Yourself
                <ArrowDownIcon className="h-5 w-5 ml-2" data-id="element-90" />
              </button>
            </div>
          </div>
          <div className="md:w-1/2 flex justify-center" data-id="element-91">
            <div className="relative w-64 h-96 bg-[#3ba69f] rounded-3xl p-4 shadow-2xl" data-id="element-92">
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-24 h-6 bg-[#2d8a84] rounded-b-lg" data-id="element-93"></div>
              <div className="bg-gray-800 h-full w-full rounded-2xl p-3 flex flex-col" data-id="element-94">
                <div className="flex items-center mb-4" data-id="element-95">
                  <div className="w-8 h-8 bg-[#54d4cb] rounded-full flex items-center justify-center mr-3" data-id="element-96">
                    <PhoneCallIcon className="h-4 w-4 text-white" data-id="element-97" />
                  </div>
                  <div className="text-white font-medium" data-id="element-98">Voxie AI</div>
                </div>
                <div className="bg-[#54d4cb] text-white p-3 rounded-lg mb-3 text-sm max-w-[80%]" data-id="element-99">
                  How can I help you today?
                </div>
                <div className="bg-gray-700 text-white p-3 rounded-lg mb-3 text-sm max-w-[80%] self-end" data-id="element-100">
                  I have chicken, spinach, pasta — recipe?
                </div>
                <div className="bg-[#54d4cb] text-white p-3 rounded-lg text-sm max-w-[80%] overflow-hidden" data-id="element-101">
                  Try a simple chicken spinach pasta: Sauté diced chicken until
                  cooked, add garlic, then spinach until wilted. Toss with
                  cooked pasta, olive oil, lemon
                </div>
                <div className="mt-auto flex" data-id="element-102">
                  <input type="text" className="bg-gray-700 text-white p-2 rounded-l-lg flex-grow text-sm" placeholder="Type your message..." data-id="element-103" />
                  <button className="bg-[#54d4cb] p-2 rounded-r-lg" data-id="element-104">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-white" data-id="element-105">
                      <path d="m22 2-7 20-4-9-9-4Z" data-id="element-106" />
                      <path d="M22 2 11 13" data-id="element-107" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Hero;